import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {config_promotion_template} from "../components/templates/configPromotionsList_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {header} from "./header";

declare var ko: any;
declare var page: any;


export class config_promotion extends vnModule_knockoutJS {

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: config_promotion_template;
    protected timer;

    public fillPage() {

        this.getReferences()
    }

    buildContent(): Array<Element> {

        this.elementsList = new config_promotion_template("list", this.viewModel, this);
        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Promotion");

        return [this.elementsList.build()];
    }

    protected getModuleName(): string {

        return "config_promotion";
    }

    protected listReorder() {

        this.filterList();
    }

    protected filterSimpleCancel(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterSimpleOnChange() {

        this.filterList();
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected filterList() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        if(this.elementsList.getTemplateViewModel().viewType() == "list"){

            this.getPromotions();
        }else{

            this.getConfigs();
        }
    }

    protected filterDropdownOnChange() {

    }

    private getReferences() {

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/promotion/references/";
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetReferencesReturn;
        this.XHRHdl.execute();
    }

    private onGetReferencesReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);
                obj.setZones(response.zones);
                obj.elementsList.setPermissions(response.permissions);

                // get promotions
                obj.getPromotions();

            });
        }
    }

    protected setZones(zones) {

        let data = [];
        zones.forEach(function (zone) {

            let opportunities = zone.pages.map(element => element.page.name).join(" / ");
            let opportunitiesTarget = zone.pages.map(element => (element.isCompeting == "1" ? "Yes" : "No"));
            let item = {
                'id': zone.id,
                'name': zone.name,
                'opportunities': opportunities,
                'opportuniyTarget': opportunitiesTarget.length > 0 ? opportunitiesTarget[0] : ""
            };
            data.push(item);
        });

        this.elementsList.setZones(data);
    }

    protected getPromotions() {

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/promotion/get/";
        let subViewModel = this.elementsList.getViewModelForRequest();
        this.timer = new Date().getTime();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetPromotionsReturn, XMLHttpRequestHandler_requestType.GET, 'promotions');

    }

    protected onGetPromotionsReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);
                obj.setPromotions(response);

                // get promotion configs
                obj.getConfigs();

                let execTime = Math.round((new Date().getTime() - obj.timer)/1000*100)/100;
                obj.elementsList.setResultInfo(response.paginatedResults.totalCount, response.paginatedResults.totalPage, execTime );

                // update the paginator
                obj.viewModel.list.pagination.itemCount(response.paginatedResults.totalCount);
            });
        }
    }

    protected setPromotions(response) {

        if(!response){
            return;
        }

        let promotions = response.paginatedResults.data || [];
        let allPromotions = response.allPromotions || [];
        let promotionsAvailableToUse = response.promotionsAvailableToUse || [];
        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        promotions.forEach(function (promotion) {

            promotion.emakiView = '/brand/' + idBrand + '/config/promotion/view/' + promotion.id;
            promotion.geo = (promotion.geos && promotion.geos.length > 0) ? promotion.geos.map(geo => geo.name).join(', ') : 'All';
            promotion.isAvailable = (promotion.isAvailable) ? "Yes" : "No";
            promotion.isLoginUser = (promotion.isLoginUser == '1') ? "Is Logged In" : (promotion.isLoginUser == '0') ? "Is Not Logged In" : "Not Applied";
            promotion.isPremiumUser = (promotion.isPremiumUser == '1') ? "Is Premium" : (promotion.isPremiumUser == '0') ? "Is Not Premium" : "Not Applied";
            promotion.isAdBlockUser = (promotion.isAdBlockUser == '1') ? "Has Ad Block" : (promotion.isAdBlockUser == '0') ? "Does Not Have Ad Block" : "Not Applied";
            promotion.isBotRequest = (promotion.isBotRequest == '1') ? "Is Bot Request" : (promotion.isBotRequest == '0') ? "Is Not Bot Request" : "Not Applied";
            promotion.has5ListItemsOrMore = (promotion.has5ListItemsOrMore == '1') ? "Has 5 Or More Items in Lists" : (promotion.has5ListItemsOrMore == '0') ? "Has Less Than 5 Items in Lists" : "Not Applied";
            promotion.isPushNotificationSubscribed = (promotion.isPushNotificationSubscribed == '1') ? "Subscribed" : (promotion.isPushNotificationSubscribed == '0') ? "Unsubscribed" : "Not Applied";
            promotion.isHighlyEngaged = (promotion.isHighlyEngaged == '1') ? "Highly Engaged" : (promotion.isHighlyEngaged == '0') ? "Not Highly Engaged" : "Not Applied";
        })

        this.elementsList.setPromotions(promotions);
        this.elementsList.setAllPromotions(allPromotions);
        this.elementsList.setPromotionsAvailableToUse(promotionsAvailableToUse);

        // LOADING : ends
        this.loadingOut(this.elementsList.builtTemplate.children.namedItem("list-results"));
    }

    protected getConfigs() {

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let usrReq_url: string = '/api/brand/' + idBrand + "/promotion/config/get/";
        let subViewModel = this.elementsList.getViewModelForRequest();
        this.sendFilterCall(usrReq_url, subViewModel, this.onGetConfigsReturn, XMLHttpRequestHandler_requestType.GET, 'promotionConfigs');

    }

    protected onGetConfigsReturn(req, obj) {

        return function () {

            obj.manageResponse(req, obj, function () {

                let response = JSON.parse(req.request.response);
                obj.elementsList.setConfigs(response.paginatedResults.data || []);

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            });
        }
    }

    protected onClickViewPromotion(id) {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/promotion/view/' + id + '/')
    }

    protected onClickAddPromotion() {

        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }

        page('/brand/' + this.getVnAppZone().app.params.idBrand + '/config/promotion/add/')
    }

    protected onClickSaveConfig() {

        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let formReq_url: string = '/api/brand/' + idBrand + "/promotion/config/save/";
        let formReq_params: Array<Array<string>> = [];
        let subViewModel = this.elementsList.getConfigs();
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    obj.elementsList.getTemplateViewModel().originalConfigs([...obj.elementsList.getTemplateViewModel().configs()]);
                    obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
                });
            }

        });
        XHRHdl.execute();
    }
}



// WEBPACK FOOTER //
// ./js/modules/config_promotion.ts